<script lang="ts" setup>
import { onBeforeRouteUpdate } from '#app'
import { blockDetailPageType } from '~/routes/blocks'
import { ITab } from '~/types/tab.type'
import BcTabs from '~/ui/Tabs/BcTabs.vue'

const route = useRoute()
const blockNumber = route.params.blockNumber as string

type IBlockTab = ITab<blockDetailPageType>

const tabList: Array<IBlockTab> = [
  {
    value: 'block',
    label: 'Block',
  },
  {
    value: 'transactions',
    label: 'Transactions',
  },
  {
    value: 'internal-transactions',
    label: 'Internal Transactions',
  }
]

const extractTabFromPath = (path: string) => {
  return path.split('/')[3] as blockDetailPageType || blockDetailPageType.block
}

const tab = ref(extractTabFromPath(route.path))

const router = useRouter()

onBeforeRouteUpdate((guard) => {
  if (routes.isBlockPage(guard.path)) tab.value = extractTabFromPath(guard.path)
})

watch(tab, () => {
  router.replace(routes.getBlockDetailPageWithTab(blockNumber, tab.value))
})
</script>

<template>
  <BcTabs
    v-model="tab"
    :list="tabList"
  />
</template>

<style scoped>

</style>